import request from './requestWrapper';

// Types
import {CancelGuideType, ReCreateGuideType} from "../types/shipmentTypes";


function cancelGuide(data: CancelGuideType) {
  return request({
    url: 'shipment/cancelGuide',
    method: 'POST',
    data: data
  });
}
function reCreateGuide(data: ReCreateGuideType) {
  return request({
    url: 'shipment/reCreateGuide',
    method: 'POST',
    data: data
  });
}

export default {
  cancelGuide, reCreateGuide,
}